import { render, staticRenderFns } from "./supplierEntryGuidelines.vue?vue&type=template&id=4bd1b529&scoped=true"
import script from "./supplierEntryGuidelines.vue?vue&type=script&lang=js"
export * from "./supplierEntryGuidelines.vue?vue&type=script&lang=js"
import style0 from "./supplierEntryGuidelines.vue?vue&type=style&index=0&id=4bd1b529&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd1b529",
  null
  
)

export default component.exports